import { useEffect, useRef, useState } from 'react';
import type { StreamChat } from 'stream-chat';
import { useStreamChatContext } from '~/react_context/StreamChatContext';
import CompanyChatModal from '../chat/company-chat/CompanyChatModal';
import { FAIcon } from '../utils/FAIcons';

export const NavChatButton = () => {
	const { streamChatClient } = useStreamChatContext();
	const [isChatOpen, setIsChatOpen] = useState(false);
	const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
	const streamChatClientEventListener = useRef<{
		unsubscribe: () => void;
	}>(undefined);

	const getInitialUnreadCount = async (streamChatClient: StreamChat) => {
		const response = await streamChatClient.getUnreadCount();
		setUnreadMessagesCount(response.total_unread_count);
	};

	useEffect(() => {
		if (!streamChatClient) return;

		getInitialUnreadCount(streamChatClient);

		streamChatClientEventListener.current = streamChatClient.on((event) => {
			if (event.unread_count !== undefined) {
				setUnreadMessagesCount(event.unread_count);
			}
		});

		return () => {
			const listener = streamChatClientEventListener.current;
			if (listener) {
				listener.unsubscribe();
			}
		};
	}, [streamChatClient]);

	return (
		<>
			<button
				className="text-white disabled:text-gray-400 disabled:cursor-not-allowed hover:bg-gray-200 hover:text-gray-900 rounded-md relative"
				disabled={!streamChatClient}
				onClick={() => setIsChatOpen(true)}
				type="button"
			>
				<FAIcon className="text-base md:text-lg font-medium px-3 py-1" icon="comments" prefix="fad" />
				{unreadMessagesCount > 0 && (
					<div className="absolute -top-3 -right-1 w-6 h-6 bg-red-600 text-white rounded-full text-sm pt-0.5">
						{unreadMessagesCount < 100 ? unreadMessagesCount : '99+'}
					</div>
				)}
			</button>
			{isChatOpen && <CompanyChatModal onClose={() => setIsChatOpen(false)} />}
		</>
	);
};
